import { useParams } from 'react-router';

import Chapter from '@/pages/Chapter/Chapter';
import Credits from '@/pages/Credits/Credits';
import ErrorPage from '@/pages/ErrorPage/ErrorPage';
import LearnMore from '@/pages/LearnMore/LearnMore';
import Timeline from '@/pages/Timeline/Timeline';
import { useNavigationStore } from '@/store/useNavigationStore';

const PAGE_COMPONENTS = {
    chapter: Chapter,
    timeline: Timeline,
    learnMore: LearnMore,
    credits: Credits,
};

function ExpoPage() {
    const { web_path } = useParams();
    const isReady = useNavigationStore((s) => s.isReady);
    const pages = useNavigationStore((s) => s.pages);
    const page = pages.find((p) => p.web_path === web_path);

    if (!isReady) return null;

    if (!page) return <ErrorPage />;

    const PageComponent = PAGE_COMPONENTS[page.type];

    return <PageComponent page={page} />;
}

export default ExpoPage;
